<template>
	<v-card v-if="item._id" outlined>
		<!-- map -->
		<v-skeleton-loader
			v-if="Boolean(item) && !changePlace"
			ref="editMapPlace"
			type="image"
			:style="{ height: $vuetify.breakpoint.sm ? '250px' : '150px' }"
			class="mx-auto"
		></v-skeleton-loader>
		<Geofence
			v-if="Boolean(item) && changePlace"
			:height-map="$vuetify.breakpoint.sm ? '250px' : '150px'"
			:id-map="item._id"
			:place="{ ...item }"
			:id-place="item._id"
		>
		</Geofence>
		<!-- title -->
		<v-card-title class="pb-1">{{ item.name }}</v-card-title>
		<v-card-title class="pt-0 text--secondary subtitle-2">
			Ha creado hasta hoy {{ countLogingsPlace }} actividades
		</v-card-title>
		<v-card-subtitle class="pb-0 text-left">rut: {{ item.rut }}</v-card-subtitle>
		<!-- content -->
		<v-list class="text-left">
			<v-subheader :class="globalBackground">Servicios</v-subheader>
			<template v-if="item && item.services.length">
				<v-list-item v-for="service in item.services" :key="service._id">
					<v-list-item-content>
						<v-list-item-title>
							{{ service.name }}
							<span class="success--text">$ </span>
							{{ service.price }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
			<template v-else>
				<Empty msj="No hay Servicios" />
			</template>
		</v-list>
		<v-list two-line>
			<v-subheader :class="globalBackground">Documentos disponibles</v-subheader>
			<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
				<template v-if="item.documents.some(el => el !== null)">
					<template v-for="(req, i) in item.typeDocuments">
						<template v-if="req !== null">
							<v-list-item
								v-if="item.documents[i]"
								:key="i"
								tile
								link
								target="_blank"
								:href="item.documents[i].url"
							>
								<v-list-item-avatar>
									<v-icon v-if="itsDue(item.documents[i].date)" color="warning">
										mdi-clock-alert-outline
									</v-icon>
									<v-icon v-else color="success">
										mdi-checkbox-marked-circle-outline
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content class="text-left">
									<v-list-item-title class="text-capitalize">
										{{ item.documents[i].text }}
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="itsDue(item.documents[i].date)"
										style="font-size: 8pt;"
										class="warning--text"
									>
										Caducado el {{ item.documents[i].date }}
									</v-list-item-subtitle>
									<v-list-item-subtitle v-else style="font-size: 8pt;">
										Creado: {{ createAt(item.documents[i].id) }}
										{{
											item.documents[i].date &&
												`- Vence: ${item.documents[i].date}`
										}}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</template>
					</template>
				</template>
				<template v-else>
					<Empty msj="No hay documentos disponibles" />
				</template>
			</v-list-item-group>
		</v-list>
		<v-list two-line>
			<v-subheader :class="globalBackground">Documentos pendientes</v-subheader>
			<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
				<template
					v-if="item.typeDocuments.some((el, i) => el !== null && !item.documents[i])"
				>
					<template v-for="(req, i) in item.typeDocuments">
						<template v-if="req !== null && !item.documents[i]">
							<v-list-item :key="i" tile>
								<v-list-item-avatar>
									<v-icon color="warning">
										mdi-file-question-outline
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="text-left text-capitalize">
										{{ req.text }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
					</template>
				</template>
				<template v-else>
					<Empty msj="No hay documentos pendientes" />
				</template>
			</v-list-item-group>
		</v-list>
		<!-- actions -->
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn outlined color="error" :loading="loadingDeletePlace" @click.stop="removePlace">
				Eliminar {{ item.name }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Empty from '@/components/ui/DataEmpty';

export default {
	name: 'PlaceCard',
	components: {
		Geofence: () => import('@/components/place/Geofence'),
		Empty,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		id: {
			type: String,
			default: '',
		},
		cleaning: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			changePlace: true,
			loadingDeletePlace: false,
		};
	},
	computed: {
		...mapGetters({
			countLogingsPlace: 'Lodging/countLogingsPlace',
		}),
	},
	methods: {
		getLodgings() {
			this.fetchLodgings(this.item._id);
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		createAt(date) {
			return moment(date).format('l');
		},
		removePlace() {
			if (confirm('Estas seguro de eliminarlo este establecimiento?')) {
				this.loadingDeletePlace = true;
				this.deletePlace(this.item._id)
					.then(() => {
						this.cleaning();
						this.fetchPlacesByIdUser(this.id);
						this.loadingDeletePlace = false;
					})
					.catch(() => (this.loadingDeletePlace = false));
			}
		},
		...mapActions({
			fetchLodgings: 'Lodging/fetchLodgings',
			fetchPlacesByIdUser: 'Place/fetchPlacesByIdUser',
			deletePlace: 'Place/deletePlace',
		}),
	},
	watch: {
		item() {
			if (!this.item.status) {
				this.getLodgings();
				this.changePlace = false;
				setTimeout(() => {
					this.changePlace = true;
				}, 100);
			}
		},
	},
};
</script>
